{
	"title": "Meet console",
	"header": {
		"title": "{{event}}, {{meet}}",
		"meetNo": "Meet <b>{{meet}}</b>",
		"position": "{{n}} of {{total}} in {{phase}}",
		"positionPool": "{{n}} of {{total}} in group {{pool}}",
		"heatSummary": "Heat summary",
		"venueIn": "{{venue}}, {{building}}",
		"scheduled": "Scheduled <time>{{time}}</time>",
		"noTime": "No start time yet",
		"advance_one": "Top {{count}} goes through to {{phase}}",
		"advance_other": "Top {{count}} go through to {{phase}}",
		"advanceAt_one": "Top {{count}} goes through to {{phase}} at {{time}}",
		"advanceAt_other": "Top {{count}} go through to {{phase}} at {{time}}",
		"advanceByPlace_one": "Top {{count}} goes through to {{phase}}: {{place}} from each heat (Q), the rest on time (q)",
		"advanceByPlace_other": "Top {{count}} go through to {{phase}}: {{place}} from each heat (Q), the rest on time (q)",
		"advanceAtByPlace_one": "Top {{count}} goes through to {{phase}} at {{time}}: {{place}} from each heat (Q), the rest on time (q)",
		"advanceAtByPlace_other": "Top {{count}} go through to {{phase}} at {{time}}: {{place}} from each heat (Q), the rest on time (q)",
		"medalEvent": "Medal event",
		"locked": "Event locked by the medal desk",
		"links": "The tie and its matches",
		"openTie": "Open the tie",
		"rubbers": "Rubbers:"
	},
	"tabs": {
		"label": "Meet sections",
		"results": "Result list",
		"startList": "Start list",
		"info": "Meet info",
		"report": "Report",
		"unsaved_one": "{{count}} result row not saved",
		"unsaved_other": "{{count}} result rows not saved",
		"medals": "Medals"
	},
	"notFound": {
		"title": "This meet does not exist",
		"body": "It may have been deleted, or the link is wrong. Find it in the meets list.",
		"toMeets": "Go to the meets list"
	},
	"status": {
		"label": "Meet status",
		"option": {
			"NONE": "No status yet",
			"START_LIST": "Start list",
			"LIVE": "Live",
			"UNOFFICIAL": "Unofficial result",
			"OFFICIAL": "Official result"
		},
		"confirmChange": "Change status",
		"staged": "Not saved yet. Nothing changes until you save.",
		"save": "Save status",
		"discard": "Cancel",
		"startListUnsaved": "Save the start list first. The status changes once the start list on the page is saved.",
		"officialBody": "The results are frozen and the medal desk is told. Slots in later meets that wait for this result are filled now. To correct it later, pick another status and save it.",
		"reopened": "The meet is unofficial again. Correct the results, then make it official.",
		"changeOfficial": {
			"title": "Change meet {{meet}} from Official to {{status}}?",
			"body": "Its results unlock so they can be corrected. Competitors this meet placed into later meets are taken out again. Make it official again when you are done."
		}
	},
	"toolbar": {
		"backToMeet": "Back to the meet"
	},
	"stepper": {
		"status": {
			"NONE": "No result",
			"START_LIST": "Start list",
			"LIVE": "Live",
			"UNOFFICIAL": "Unofficial",
			"OFFICIAL": "Official"
		},
		"forward": {
			"NONE": "Clear the status",
			"START_LIST": "Publish start list",
			"LIVE": "Go live",
			"UNOFFICIAL": "Mark unofficial",
			"OFFICIAL": "Make official"
		},
		"done": {
			"NONE": "The meet has no result status now.",
			"START_LIST": "Start list published.",
			"LIVE": "The meet is live.",
			"UNOFFICIAL": "Marked unofficial."
		},
		"blocked": {
			"notReady": "Not possible from the current status.",
			"unsaved_one": "{{count}} row is not saved yet. Save or discard it before marking the result unofficial or official.",
			"unsaved_other": "{{count}} rows are not saved yet. Save or discard them before marking the result unofficial or official.",
			"noOutcome": "No winner yet: enter the score in the result list first (a draw counts).",
			"impossibleGames_one": "Game {{games}} has a score the rules do not allow, or was played after the match was won. Correct it first.",
			"impossibleGames_other": "Games {{games}} have scores the rules do not allow, or were played after the match was won. Correct them first."
		},
		"confirmBack": {
			"title": "Move the meet back to {{status}}?",
			"body": "Results already entered stay as they are. Everyone watching this meet will see the earlier status."
		},
		"confirmOfficial": {
			"title": "Make meet {{meet}} official?",
			"medals": "This meet decides medals. Once it is official, send the suggested podium to the medal desk from Medals.",
			"goalsMismatch": "The goals logged ({{goals}}) do not match the score ({{score}}). Check the match events before making it official.",
			"noLineup": "{{team}} has no line-up entered."
		}
	},
	"actionError": {
		"stale": "Someone changed this meet first. It has been reloaded: check it and try again.",
		"familyChanged": "This meet's result settings changed. Reload the meet.",
		"official": "This meet is already official. Change its Meet status first.",
		"locked": "The medal desk has locked this event. Nothing can change until it is unlocked.",
		"outcomeMissing": "This meet decides who goes on, so it needs exactly one winner before it can be official.",
		"started_one": "{{count}} later meet has already started with a competitor from this one. Changing the official result is refused.",
		"started_other": "{{count}} later meets have already started with competitors from this one. Changing the official result is refused.",
		"startedList": "These later meets have already started with competitors from this one: {{meets}}. Changing the official result is refused.",
		"duplicateFill": "Two slots of one later meet would take the same competitor. The bracket needs fixing in GMS.",
		"needsCompetitor": "Put at least one competitor on the start list first."
	},
	"report": {
		"officialTitle": "Meet {{meet}} is official",
		"nothingFed": "No later meet waits for this result.",
		"autoAdvanced_one": "The top {{count}} of the round went through to {{phase}}",
		"autoAdvanced_other": "The top {{count}} of the round went through to {{phase}}",
		"autoEntered_one": "{{count}} competitor added to {{phase}}",
		"autoEntered_other": "{{count}} competitors added to {{phase}}",
		"autoDropped_one": "{{count}} competitor taken out (no longer in the top places)",
		"autoDropped_other": "{{count}} competitors taken out (no longer in the top places)",
		"autoNotDropped_one": "{{count}} competitor is no longer in the top places but already has a lane in the next round. Remove them from that start list if needed.",
		"autoNotDropped_other": "{{count}} competitors are no longer in the top places but already have a lane in the next round. Remove them from those start lists if needed.",
		"autoSkipped": "Nobody was sent to {{phase}} automatically",
		"autoSkip": {
			"TIE_AT_CUT": "More than {{count}} share the places that go through. Break the tie, then use Advance on the standings (or Sync on the next round's start list).",
			"BY_PLACE_OVER_COUNT": "The places by heat (Q) add up to more than {{count}}. Lower \"from each heat\" or raise how many go on, then use Advance.",
			"POOLS": "This round is drawn in groups. Use Advance on the standings to choose who goes through.",
			"DECISIONS": "Someone was put through or made a reserve by hand. Use Advance on the standings to update the list."
		},
		"filled_one": "{{count}} slot filled",
		"filled_other": "{{count}} slots filled",
		"filledLine": "{{name}} into meet {{meet}}",
		"notRefilled_one": "{{count}} slot not changed",
		"notRefilled_other": "{{count}} slots not changed",
		"notRefilledHint": "Their meet has started or already holds a result, so they were left as they were. Fix them on that meet's start list if needed.",
		"unresolved_one": "{{count}} slot still open",
		"unresolved_other": "{{count}} slots still open",
		"unresolvedHint": "This result does not decide them yet (for example a shared rank).",
		"slotWith": "Meet {{meet}}: {{source}}",
		"slotIn": "A slot in meet {{meet}}",
		"unknownSlot": "A slot in another meet",
		"someone": "A competitor",
		"reopenTitle": "Meet {{meet}} is no longer official",
		"reopenBody": "The meet is unofficial again. Correct the results, then make it official.",
		"unfilled_one": "{{count}} slot emptied again",
		"unfilled_other": "{{count}} slots emptied again",
		"unfilledLine": "{{name}} taken out of meet {{meet}}"
	},
	"source": {
		"winnerOf": "Winner of {{meet}}",
		"loserOf": "Loser of {{meet}}",
		"rankOfMeet": "Rank {{rank}} in {{meet}}",
		"rankOfPool": "Rank {{rank}} in group {{pool}}",
		"rankOfPhase": "Rank {{rank}} in the phase",
		"unknown": "To be decided"
	},
	"side": {
		"HOME": "Home",
		"AWAY": "Away",
		"RED": "Red corner",
		"BLUE": "Blue corner",
		"WHITE": "White corner",
		"AKA": "Aka (red)",
		"AO": "Ao (blue)"
	},
	"rail": {
		"label": "Standings",
		"hide": "Close standings",
		"unsaved_one": "{{count}} unsaved",
		"unsaved_other": "{{count}} unsaved",
		"conflicts_one": "{{count}} conflict",
		"conflicts_other": "{{count}} conflicts",
		"refused_one": "{{count}} not accepted",
		"refused_other": "{{count}} not accepted",
		"restored_one": "{{count}} unsaved row came back from this device.",
		"restored_other": "{{count}} unsaved rows came back from this device.",
		"standings": "{{phase}} standings",
		"standingsPool": "Group {{pool}} standings",
		"fullStandings": "Full standings",
		"standingsError": "The standings could not load.",
		"standingsEmpty": "No results count towards the standings yet.",
		"colRank": "Rank",
		"colCompetitor": "Competitor",
		"colRecord": "Won, drawn, lost",
		"colPoints": "Points",
		"colResult": "Result",
		"record": "{{won}}-{{drawn}}-{{lost}}",
		"recordHint": "Won, drawn, lost",
		"fillsNext": "Goes on to",
		"fillsNone": "No open slot in a later meet waits for this result.",
		"fillsIn": "Meet {{meet}}",
		"advance_one": "Top {{count}} goes through to {{phase}}.",
		"advance_other": "Top {{count}} go through to {{phase}}.",
		"advanceAt_one": "Top {{count}} goes through to {{phase}} at {{time}}.",
		"advanceAt_other": "Top {{count}} go through to {{phase}} at {{time}}.",
		"advanceByPlace_one": "Top {{count}} goes through to {{phase}}: {{place}} from each heat (Q), the rest on time (q).",
		"advanceByPlace_other": "Top {{count}} go through to {{phase}}: {{place}} from each heat (Q), the rest on time (q).",
		"advanceAtByPlace_one": "Top {{count}} goes through to {{phase}} at {{time}}: {{place}} from each heat (Q), the rest on time (q).",
		"advanceAtByPlace_other": "Top {{count}} go through to {{phase}} at {{time}}: {{place}} from each heat (Q), the rest on time (q).",
		"goesThrough": "Goes through",
		"recent": "Recent changes",
		"recentNone": "No result saved yet.",
		"lane": "Lane {{lane}}",
		"order": "Order {{order}}",
		"inRubber": "{{meet}}, {{place}}"
	},
	"saveBar": {
		"offline": "No connection to the server. Your edits are kept on this device and sent when it is back.",
		"conflicts_one": "{{count}} row was changed by someone else.",
		"conflicts_other": "{{count}} rows were changed by someone else.",
		"refused_one": "{{count}} row was not accepted.",
		"refused_other": "{{count}} rows were not accepted.",
		"unsaved_one": "{{count}} row not saved yet.",
		"unsaved_other": "{{count}} rows not saved yet.",
		"kept": "Kept on this device until it saves.",
		"typing": "Typing: the row is not saved until you press Enter.",
		"saving": "Saving…",
		"saved": "Everything is saved",
		"saveAll": "Save all ({{count}})",
		"discardAll": "Discard all",
		"discardConfirm": {
			"title_one": "Discard {{count}} unsaved row?",
			"title_other": "Discard {{count}} unsaved rows?",
			"body": "Your typed values are removed from this device."
		},
		"lock": {
			"official": "This meet is official. To change a result, change the Meet status (you will be asked to confirm).",
			"locked": "The medal desk has locked this event. Results cannot change until it is unlocked.",
			"cancelled": "This meet is cancelled. Restore it to scheduled to enter results."
		},
		"keysLabel": "Keys",
		"keyEnter": "Enter",
		"keyTab": "Tab",
		"keyEsc": "Esc",
		"hintEnter": "saves the row and moves down",
		"hintTab": "next field",
		"hintEsc": "undoes"
	},
	"details": {
		"title": "Meet details",
		"zone": "Times are in your time zone ({{zone}}).",
		"notSet": "Not set",
		"event": "Event",
		"meetNo": "Meet number",
		"stage": "Meet stage",
		"group": "Group {{group}}",
		"start": "Start",
		"end": "End",
		"schedule": "Schedule",
		"scheduledStart": "Scheduled start",
		"scheduledEnd": "Scheduled end",
		"where": "Venue and status",
		"venue": "Venue",
		"venueNone": "No venue",
		"area": {
			"COURT": "Court",
			"RING": "Ring",
			"MAT": "Mat",
			"PISTE": "Piste",
			"PITCH": "Pitch",
			"TABLE": "Table",
			"LANE": "Lane",
			"RANGE": "Range",
			"RINK": "Rink",
			"AREA": "Area"
		},
		"areaNone": {
			"COURT": "No courts listed at this venue",
			"RING": "No rings listed at this venue",
			"MAT": "No mats listed at this venue",
			"PISTE": "No pistes listed at this venue",
			"PITCH": "No pitches listed at this venue",
			"TABLE": "No tables listed at this venue",
			"LANE": "No lanes listed at this venue",
			"RANGE": "No ranges listed at this venue",
			"RINK": "No rinks listed at this venue",
			"AREA": "No areas listed at this venue"
		},
		"wholeVenue": "Whole venue",
		"areaTyped": "Type a name…",
		"areaTypedLabel": "Name",
		"areaPlaceholder": "e.g. Ring A",
		"areaNameTooLong": "{{max}} characters at most",
		"scheduleStatus": "Schedule status",
		"remarks": "Remarks",
		"remarksHint": "{{used}} of {{max}} characters. Shown with the meet on every OVR screen.",
		"video": "Video link",
		"videoHint": "Paste a YouTube or Facebook video link. The portal shows it while the meet is live.",
		"videoNone": "No video link",
		"featured": "Featured on the home page",
		"featuredHint": "Plays first among the live videos on the home page.",
		"featuredYes": "Featured on the home page",
		"featuredNo": "Not featured",
		"changed": "Changed",
		"pending_one": "{{count}} change not saved yet.",
		"pending_other": "{{count}} changes not saved yet.",
		"clean": "No changes.",
		"discard": "Discard changes",
		"save": "Update meet",
		"saved": "Meet details saved",
		"invalid": "Check the fields marked above.",
		"lock": {
			"role": "Your role can view this meet's details but not change them.",
			"locked": "The medal desk has locked this event. Its details cannot change until it is unlocked."
		}
	},
	"form": {
		"timestampFormat": "Enter a date and time",
		"endBeforeStart": "The end is before the start",
		"tooLong": "{{max}} characters at most",
		"nothingToChange": "Change a field first",
		"officialWhoRequired": "Type the official's name",
		"positionRepeated": "Each position may be given to one official only",
		"officialIdRepeated": "Each official may appear only once"
	},
	"officials": {
		"title": "Officials",
		"count_one": "{{count}} official",
		"count_other": "{{count}} officials",
		"none": "No officials listed for this meet.",
		"noneYet": "No officials yet. Add the referee, judges or timekeepers who run this meet.",
		"col": {
			"name": "Name",
			"role": "Role",
			"position": "Position",
			"team": "With team"
		},
		"neutral": "Neutral",
		"teamWithSide": "{{team}} ({{side}})",
		"registered": "Registered person",
		"unnamed": "Official {{n}}",
		"nameFor": "Name of official {{n}}",
		"roleFor": "Role of {{name}}",
		"positionFor": "Position of {{name}}",
		"teamFor": "Team of {{name}}",
		"positionPlaceholder": "J1",
		"remove": "Remove",
		"removeName": "Remove {{name}}",
		"add": "Add official",
		"max": "At most {{max}} officials per meet.",
		"pending": "Changes not saved yet.",
		"clean": "No changes.",
		"fixRows": "Fix the rows marked above.",
		"discard": "Discard changes",
		"save": "Save officials",
		"saved": "Officials saved",
		"invalid": "Check the rows marked above.",
		"refused": "The officials were not saved: a person or team on the list is no longer valid. Reload the meet and try again.",
		"stale": "Someone changed the officials after you started editing.",
		"staleHint": "Keep mine saves your list over theirs. Take theirs throws your edits away.",
		"lock": {
			"role": "Your role can view this meet's officials but not change them.",
			"locked": "The medal desk has locked this event. Its officials cannot change until it is unlocked."
		},
		"foldNone": "None listed yet"
	},
	"print": {
		"title": "Print result sheet",
		"hint": "An A4 sheet of this meet's results, stamped Unofficial until the meet is official. To keep a PDF, pick Save as PDF as the printer.",
		"hintOfficial": "An A4 sheet of this meet's official results. To keep a PDF, pick Save as PDF as the printer.",
		"button": "Print",
		"preview": "Result sheet preview",
		"path": "{{sport}} › {{discipline}}",
		"meet": "Meet",
		"phase": "Phase",
		"venue": "Venue",
		"scheduled": "Scheduled",
		"officials": "Officials",
		"signature": "Signature",
		"printedAt": "Printed {{time}}",
		"empty": "Nobody is on this meet's start list yet.",
		"waiting": "To be decided",
		"col": {
			"rank": "Rank",
			"lane": "Lane",
			"side": "Side",
			"order": "Order",
			"bib": "Bib",
			"name": "Name",
			"noc": "NOC",
			"result": "Result",
			"irm": "IRM",
			"records": "Records",
			"lot": "Lot",
			"bodyweight": "Body wt",
			"snatch": "Snatch",
			"cleanJerk": "Clean & Jerk",
			"best": "Best",
			"total": "Total",
			"reaction": "Reaction",
			"points": "Points",
			"totalPoints": "Total points",
			"q": "Q"
		},
		"status": "Result status: {{status}}",
		"separator": " · ",
		"wind": "Wind",
		"windValue": "{{wind}} m/s",
		"splitAt": "{{distance}} m",
		"splitN": "Split {{n}}",
		"heightCard": "Height card",
		"legendItem": "{{mark}} {{word}}",
		"combinedTitle": "Standings after {{discipline}} (discipline {{n}} of {{total}})",
		"lineups": "Line-ups",
		"starters": "Starting line-up",
		"substitutes": "Substitutes",
		"captain": "C",
		"captainLong": "Captain",
		"matchSummary": "Match summary",
		"goals": "Goals",
		"cards": "Cards",
		"substitutions": "Substitutions",
		"penalty": "pen.",
		"ownGoal": "own goal",
		"eventLine": "{{minute}} {{name}}",
		"eventNote": "{{minute}} {{name}} ({{note}})",
		"cardLine": "{{minute}} {{card}}: {{name}}",
		"subLine": "{{minute}} {{on}} for {{off}}",
		"subOn": "{{minute}} {{on}} on"
	},
	"delete": {
		"locked": "The medal desk has locked this event, so this meet cannot be deleted until it is unlocked.",
		"button": "Delete meet",
		"confirmTitle": "Delete meet {{meet}}?",
		"confirmBody": "The meet is removed for everyone with its start list, every saved result, its officials and, for a team tie, its matches. Anyone it sent to the next round is taken back out, and its places in later meets that have not started yet are removed. This cannot be undone.",
		"reasonLabel": "Why is it being deleted?",
		"reasonPlaceholder": "For example: created twice, wrong event",
		"reasonRequired": "Give a reason for deleting the meet.",
		"done": "Meet {{meet}} deleted",
		"medals_one": "A medal has been awarded from this meet, so it cannot be deleted. The medal desk must take it away first.",
		"medals_other": "{{count}} medals have been awarded from this meet, so it cannot be deleted. The medal desk must take them away first.",
		"tsrLiveTitle": "TSR is holding live scores for this meet.",
		"tsrLive": "If the operator has not pressed Save Meet, deleting throws those scores away for good: they are not saved anywhere else.",
		"started_one": "A later meet has already started with a competitor this meet sent on, so it cannot be deleted. Take them off that meet first.",
		"started_other": "{{count}} later meets have already started with competitors this meet sent on, so it cannot be deleted. Take them off those meets first.",
		"gone": "This meet no longer exists. Someone else may have deleted it."
	},
	"clearResults": {
		"confirmTitle": "Clear the results of meet {{meet}}?",
		"confirmBody": "Every saved score, rank, time and statistic on this meet is removed for everyone, and anyone it sent to the next round is taken back out. The start list stays. This cannot be undone.",
		"reasonLabel": "Why are the results being cleared?",
		"reasonPlaceholder": "For example: entered on the wrong meet",
		"reasonRequired": "Give a reason for clearing the results.",
		"button": "Clear results",
		"done_one": "Meet {{meet}}: {{count}} result cleared",
		"done_other": "Meet {{meet}}: {{count}} results cleared",
		"nothing": "Meet {{meet}} had no results to clear",
		"unadvanced_one": "{{count}} competitor was taken out of the next round",
		"unadvanced_other": "{{count}} competitors were taken out of the next round",
		"stillAdvanced_one": "{{count}} competitor already has a place in a next-round meet and stays qualified. Remove them from that start list, then clear again.",
		"stillAdvanced_other": "{{count}} competitors already have a place in a next-round meet and stay qualified. Remove them from that start list, then clear again.",
		"medals": "A medal has been awarded from these results, so they cannot be cleared."
	},
	"actions": {
		"more": "More actions for meet {{meet}}",
		"moreTitle": "More actions",
		"menuLabel": "Meet actions",
		"lockedHint": "The medal desk has locked this event.",
		"postpone": "Postpone…",
		"restore": "Restore to scheduled",
		"clearResults": "Clear results…",
		"delete": "Delete meet…",
		"postponeTitle": "Postpone meet {{meet}}?",
		"postponeBody": "The meet shows as postponed everywhere until it is restored to scheduled. Results already entered stay.",
		"postponePlaceholder": "For example: lightning, pool closed until tomorrow",
		"postponeConfirm": "Postpone meet",
		"restoreTitle": "Restore meet {{meet}} to scheduled?",
		"restoreBody": "The meet goes back to scheduled; results can be entered again.",
		"restorePlaceholder": "For example: weather cleared",
		"restoreConfirm": "Restore to scheduled",
		"newStart": "New scheduled start (optional)",
		"newStartHint": "In your time zone. The end moves with it, so the meet keeps its length.",
		"reasonLabel": "Why? (shown in the activity log)",
		"reasonOptional": "Why? (optional)",
		"back": "Keep as it is",
		"done": {
			"postpone": "Meet {{meet}} postponed",
			"restore": "Meet {{meet}} restored to scheduled"
		}
	},
	"banner": {
		"postponed": "This meet is postponed.",
		"cancelled": "This meet is cancelled. Results cannot be entered until it is restored to scheduled."
	},
	"medal": {
		"label": "Medal event",
		"yes": "Yes",
		"no": "No",
		"on": "Medals are awarded in {{phase}}.",
		"off": "{{phase}} awards no medals.",
		"noMedalEvent": "This event awards no medals — change it in GMS (admins).",
		"confirmOnTitle": "Award medals in {{phase}}?",
		"confirmOffTitle": "Stop awarding medals in {{phase}}?",
		"confirmBody_one": "This applies to the {{count}} meet of “{{phase}}”.",
		"confirmBody_other": "This applies to all {{count}} meets of “{{phase}}”.",
		"turnOn": "Award medals",
		"turnOff": "Stop awarding medals",
		"doneOn": "{{phase}} now awards medals",
		"doneOff": "{{phase}} no longer awards medals",
		"changed": "The phase changed while it was being saved. It has been reloaded: try again."
	},
	"nextStage": {
		"label": "Next stage",
		"count": "How many go on to the next stage",
		"on_one": "The top {{count}} of {{phase}} goes on to the next stage.",
		"on_other": "The top {{count}} of {{phase}} go on to the next stage.",
		"onByPlace_one": "The top {{count}} of {{phase}} goes on: {{place}} from each heat by place (Q), the rest on time (q).",
		"onByPlace_other": "The top {{count}} of {{phase}} go on: {{place}} from each heat by place (Q), the rest on time (q).",
		"off": "Nobody from {{phase}} is marked to go on. Leave it empty if none.",
		"save": "Save",
		"done_one": "{{phase}}: the top {{count}} goes on",
		"done_other": "{{phase}}: the top {{count}} go on",
		"doneByPlace_one": "{{phase}}: the top {{count}} goes on, {{place}} from each heat by place",
		"doneByPlace_other": "{{phase}}: the top {{count}} go on, {{place}} from each heat by place",
		"cleared": "{{phase}}: nobody is marked to go on",
		"badCount": "Enter a whole number from 1 to {{max}}, or leave it empty",
		"byPlaceLabel": "From each heat by place (Q)",
		"byPlaceHint": "How many of each heat go on by their place (Q). Leave it empty to send everyone on time (q).",
		"badByPlace": "From each heat: enter a whole number from 1 to {{max}}, or leave it empty",
		"byPlaceNeedsCount": "Set how many go on before how many go from each heat",
		"byPlaceOverCount_one": "From each heat can be at most {{count}}, the number that goes on",
		"byPlaceOverCount_other": "From each heat can be at most {{count}}, the number that go on",
		"changed": "The stage changed while it was being saved. It has been reloaded: try again."
	},
	"stage": {
		"title": "Stage settings: {{phase}}",
		"appliesTo": "These apply to every meet in {{phase}}, not only this one.",
		"advance_one": "Top {{count}} goes on",
		"advance_other": "Top {{count}} go on",
		"advanceByPlace_one": "Top {{count}} goes on: {{place}} from each heat (Q), the rest on time (q)",
		"advanceByPlace_other": "Top {{count}} go on: {{place}} from each heat (Q), the rest on time (q)",
		"advanceNone": "No next-stage count set"
	},
	"officialRole": {
		"REFEREE": "Referee",
		"UMPIRE": "Umpire",
		"JUDGE": "Judge",
		"STARTER": "Starter",
		"TIMEKEEPER": "Timekeeper",
		"TECHNICAL_DELEGATE": "Technical delegate",
		"COACH": "Coach",
		"MANAGER": "Manager",
		"OTHER": "Official"
	},
	"leave": {
		"title": "Leave with unsaved results?",
		"body_one": "{{count}} row is not saved yet. It stays on this device and comes back when you open the meet again, but nobody else can see it.",
		"body_other": "{{count}} rows are not saved yet. They stay on this device and come back when you open the meet again, but nobody else can see them.",
		"confirm": "Leave anyway",
		"stay": "Stay on this meet",
		"formsTitle": "Leave without saving your changes?",
		"formsBody": "Your changes to the meet details, status or officials are not saved. They are lost if you leave."
	},
	"familyChanged": {
		"title": "This meet's result settings changed",
		"body": "Someone changed how this meet is scored (it is now {{family}}). This screen no longer matches it, so nothing more is sent until you reload.",
		"drafts": "Your unsaved edits are kept on this device. Edits that do not fit the new settings will be refused; you can discard them.",
		"reload": "Reload the meet",
		"discard": "Discard unsaved edits"
	},
	"live": {
		"on": "Connection ON",
		"connecting": "Connecting…",
		"off": "Connection OFF",
		"onHint": "Live: changes from TSR, other operators and the medal desk appear here at once. Round trip {{ms}} ms.",
		"onHintNoRtt": "Live: changes from TSR, other operators and the medal desk appear here at once.",
		"connectingHint": "Opening the live line. Until it is up, this meet refreshes on its usual timer.",
		"offHint": "No live line. This meet still refreshes on its usual timer; changes from TSR may take a few seconds to appear."
	},
	"bye": {
		"label": "Bye",
		"openTitle": "{{name}} has no opponent in this match.",
		"openBody": "Give the bye and they win without playing. Make the meet official to send them to the next round.",
		"give": "Give bye",
		"givenTitle": "{{name}} wins on a bye.",
		"givenBody": "Make the meet official to send them to the next round.",
		"officialBody": "The bye is official.",
		"remove": "Remove bye",
		"given": "Bye given to {{name}}.",
		"removed": "Bye removed from {{name}}.",
		"oneSlotOnly": "A bye is only for a match with one competitor. Remove the other side from the start list first.",
		"saveFirst": "Save or discard the changes below first.",
		"nothingToScore": "Won on a bye: there is nothing to score in this match."
	},
	"streamCopy": {
		"button": "Use this link for the event's other meets",
		"title": "Use this link for the other meets?",
		"body_one": "This sets the link on {{count}} other meet of {{event}}.",
		"body_other": "This sets the link on {{count}} other meets of {{event}}.",
		"none": "Every other meet of {{event}} you can change already has this link, or is cancelled or locked. Nothing would change.",
		"confirm": "Set the link",
		"close": "Close",
		"done_one": "Link set on {{count}} meet.",
		"done_other": "Link set on {{count}} meets.",
		"doneNone": "Nothing changed: the other meets already have this link.",
		"noLink": "Save a video link on this meet first.",
		"forbidden": "You cannot change this event's meets."
	}
}
